import { transformKeysToCamelCase } from 'shared/functions';

export const getUnreadIds = data =>
  data
    .map(item => transformKeysToCamelCase(item))
    .filter(({ isRead }) => isRead === false)
    .map(({ id }) => id);
